<template>
  <div id="infrastructure_view">
    <div class="card_content">
      <ContentViewVue>
        <div class="card" 
        v-for="(item, index) in 6" 
        :key="index"
        :style="{'background-image': `url(${getBackGroundImage(index)})`}"
        >
          <div class="card_label">{{$t(`service.SERVICE_CARD_LABEL_${index}`)}}</div>
          <div class="card_text">{{$t(`service.SERVICE_CARD_TEXT_${index}`)}}</div>
      </div>
      </ContentViewVue>
    </div>


  </div>
</template>

<script setup lang="ts">
import ContentViewVue from '@/components/ContentView.vue'


const getBackGroundImage = (index:number) => require(`@/assets/service/service_tag_0${index}.png`)
</script>

<style lang="less" scoped>
#infrastructure_view {
  width: 100%;
  margin-bottom: 1rem;
  margin-top: 2rem;


  .card_content {
    max-width: calc(var(--view-max-width) + 1rem);
    padding: 0 1rem;
    margin: 0 auto;
    

    .card {
      height: 0;
      padding-bottom: 125%;
      overflow: hidden;
      position: relative;
      color: #fff;
      background-size: cover;

      &_label {
        font-size: var(--service-card-label);
        position: absolute;
        top: 10%;
        left: 10%;
        font-weight: 500;
      }

      &_text {
        font-size: var(--service-card-text);
        max-width: 80%;
        color: rgba(255, 255, 255, 0.8);
        line-height: 1.5rem;
        position: absolute;
        top: 30%;
        left: 10%;
      }
    }
  }

}
</style>